/**
 * FH-A11Y batch 8 (2026-09-26): screen reader findings from the Orca walkthrough.
 * SR1 Globo clear buttons, SR2 card price labels, SR3 empty cart (focus, no false error), SR4 cart
 * announcements and drawer focus, SR5 sort name, SR7 price sliders, cart name links, nested nav landmark.
 * Cart fixes patch the theme's cart classes at runtime, so the theme's cart files are unchanged.
 * Rollback: remove the ada-a11y-batch8.js line at the end of snippets/freshdesk.liquid, and restore
 * sections/cart-icon-bubble.liquid (original in its comment).
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch8) return;
  window.__fhA11yBatch8 = true;

  var FOCUSABLE = 'a[href], button, input, select, textarea, summary, [tabindex]';
  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function removeAttr(el, name) {
    if (el.hasAttribute(name)) el.removeAttribute(name);
  }

  /* Shared polite announcer. While the cart drawer (an aria-modal dialog) is open, the live region
     is placed inside it, because screen readers ignore content outside an open modal. */
  var announceTimer = 0, clearTimer = 0;
  function liveRegion() {
    var host = document.querySelector('cart-drawer.active .drawer__inner') || document.body;
    var el = host.querySelector(':scope > .fh-a11y-live');
    if (!el) {
      el = document.createElement('div');
      el.className = 'fh-a11y-live visually-hidden';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      host.appendChild(el);
    }
    return el;
  }
  function announce(msg, delay) {
    var el = liveRegion();
    clearTimeout(announceTimer); clearTimeout(clearTimer);
    el.textContent = '';
    announceTimer = setTimeout(function () {
      liveRegion().textContent = msg;
      clearTimer = setTimeout(function () { liveRegion().textContent = ''; }, 7000);
    }, delay || 250);
  }
  window.fhA11yAnnounce = announce;

  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function isActKey(e) { return e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'; }
  function globoCount() {
    var b = document.querySelector('#gf-tree .gf-filter-footer b');
    var n = txt(b);
    return n ? n + (n === '1' ? ' product.' : ' products.') : '';
  }
  function globoLoading() {
    var c = document.documentElement.classList;
    return c.contains('spf-filter-loading') || c.contains('gf-loading') || !!document.querySelector('#gf-products.loading, .gf-loading');
  }

  /* SR1: Globo "Clear All", the remove (x) link on each selected-filter chip, and each group's "Clear"
     are <a> tags with no href, so they can't be reached with the keyboard. Make them buttons, name them,
     and after Globo re-renders, put focus somewhere sensible and announce the result. */
  var globoPending = null;
  function firstVisible(sel) {
    var list = document.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) if (list[i].getClientRects().length) return list[i];
    return null;
  }
  function globoAfterClear(kind, label, group) {
    globoPending = { kind: kind, label: label, group: group, t: Date.now() };
    var tries = 0;
    (function wait() {
      tries++;
      if (!globoPending) return;
      if ((globoLoading() || Date.now() - globoPending.t < 400) && tries < 60) { setTimeout(wait, 100); return; }
      var p = globoPending; globoPending = null;
      var targets = [
        p.kind === 'chip' ? firstVisible('.globo-selected-items .selected-item > a[data-fh-gf-clear]') : null,
        p.kind === 'group' && p.group ? firstVisible('#gf-tree li[data-fh-gf-key^="' + p.group + '|"][tabindex="0"]') : null,
        firstVisible('#gf-tree li[role="checkbox"][tabindex="0"], #gf-tree li[role="radio"][tabindex="0"]'),
        firstVisible('.sort-by-toggle')
      ];
      for (var i = 0; i < targets.length; i++) {
        var tg = targets[i];
        if (!tg) continue;
        try { tg.focus({ preventScroll: false }); } catch (e) { tg.focus(); }
        if (document.activeElement === tg) break;
      }
      var msg = p.kind === 'all' ? 'All filters cleared.' : (p.label ? p.label + ' removed.' : 'Filter removed.');
      announce(msg + (globoCount() ? ' ' + globoCount() : ''), 600);
    })();
  }
  function makeGloboButton(a, name, kind) {
    setAttr(a, 'role', 'button');
    setAttr(a, 'tabindex', '0');
    setAttr(a, 'aria-label', name);
    setAttr(a, 'data-fh-gf-clear', kind);
    if (a.__fhGfBound) return;
    a.__fhGfBound = true;
    a.addEventListener('keydown', function (e) {
      if (!isActKey(e)) return;
      e.preventDefault();
      e.stopPropagation();
      a.click();
    });
    a.addEventListener('click', function () {
      var g = (a.getAttribute('onclick') || '').match(/removeFilter\((\d+)\)/);
      globoAfterClear(a.getAttribute('data-fh-gf-clear'), a.getAttribute('data-fh-gf-label') || '', g ? g[1] : '');
    });
  }
  function fixGloboClearControls() {
    document.querySelectorAll('a.gf-refine-toggle').forEach(function (a) {
      if (/clear/i.test(txt(a))) makeGloboButton(a, 'Clear all filters', 'all');
    });
    document.querySelectorAll('button.clear-refinements').forEach(function (b) {
      setAttr(b, 'aria-label', 'Clear all filters');
      if (b.__fhGfBound) return;
      b.__fhGfBound = true;
      b.addEventListener('click', function () { globoAfterClear('all', ''); });
    });
    document.querySelectorAll('.globo-selected-items .selected-item > a').forEach(function (a) {
      var label = txt(a.querySelector('span.selected-item')) || txt(a);
      setAttr(a, 'data-fh-gf-label', 'Filter ' + label);
      makeGloboButton(a, 'Remove filter: ' + label, 'chip');
      a.querySelectorAll('.gf-clear').forEach(function (x) { setAttr(x, 'aria-hidden', 'true'); });
    });
    document.querySelectorAll('a.gf-clear').forEach(function (a) {
      if (a.closest('.globo-selected-items')) return;
      var block = a.closest('.gf-option-block') || a.closest('[class*="gf-option-"]') || a.parentElement;
      var title = '';
      var t = block && block.querySelector('.gf-block-title .h3, .gf-block-title h3, .gf-block-title span, h3, .h3');
      if (t) title = txt(t).replace(/\bclear\b/ig, '').trim();
      setAttr(a, 'data-fh-gf-label', (title || 'Filter') + ' filter');
      makeGloboButton(a, title ? 'Clear ' + title + ' filter' : 'Clear filter', 'group');
    });
  }

  /* SR2: Globo's product cards show the old and sale price with no words, so they're read as
     "$46.98 $34.49". Add hidden "Regular price" / "Sale price" labels. */
  function fixGloboCardPrices() {
    document.querySelectorAll('.spf-product-card__price-wrapper').forEach(function (w) {
      var oldP = w.querySelector('.spf-product-card__oldprice');
      var saleP = w.querySelector('.spf-product-card__saleprice');
      if (!oldP || !saleP || !txt(oldP)) return;
      if (!oldP.previousElementSibling || !oldP.previousElementSibling.classList.contains('fh-a11y-price-label')) {
        var l1 = document.createElement('span');
        l1.className = 'visually-hidden fh-a11y-price-label';
        l1.textContent = 'Regular price ';
        oldP.parentNode.insertBefore(l1, oldP);
      }
      if (!saleP.previousElementSibling || !saleP.previousElementSibling.classList.contains('fh-a11y-price-label')) {
        var l2 = document.createElement('span');
        l2.className = 'visually-hidden fh-a11y-price-label';
        l2.textContent = ', Sale price ';
        saleP.parentNode.insertBefore(l2, saleP);
      }
    });
  }

  /* SR5: the sort button was read as "Featured" with no "Sort by". */
  function fixGloboSort() {
    document.querySelectorAll('.sort-by-toggle').forEach(function (t) {
      var v = txt(t);
      if (v) setAttr(t, 'aria-label', 'Sort by: ' + v);
    });
  }

  /* SR7: price sliders were named by a number (aria-labelledby pointed at the number box, overriding
     "Minimum price"/"Maximum price"), and their values had no currency. Fixed synchronously so the
     screen reader hears the corrected value while the handle is moved. */
  function fixSliderHandle(h) {
    if (h.hasAttribute('aria-labelledby')) h.removeAttribute('aria-labelledby');
    if (!h.getAttribute('aria-label')) setAttr(h, 'aria-label', h.classList.contains('noUi-handle-upper') ? 'Maximum price' : 'Minimum price');
    var vt = h.getAttribute('aria-valuetext') || h.getAttribute('aria-valuenow') || '';
    if (vt && vt.charAt(0) !== '$') {
      var n = parseFloat(vt);
      if (!isNaN(n)) h.setAttribute('aria-valuetext', '$' + n.toFixed(2));
    }
  }
  var sliderMO = null;
  function fixGloboPriceSliders() {
    var hs = document.querySelectorAll('.noUi-handle[role="slider"]');
    if (!hs.length) return;
    if (!sliderMO) {
      sliderMO = new MutationObserver(function (list) {
        list.forEach(function (m) { if (m.target.classList && m.target.classList.contains('noUi-handle')) fixSliderHandle(m.target); });
      });
    }
    hs.forEach(function (h) {
      fixSliderHandle(h);
      if (!h.__fhObs) { h.__fhObs = true; sliderMO.observe(h, { attributes: true, attributeFilter: ['aria-valuetext', 'aria-valuenow', 'aria-labelledby'] }); }
    });
  }

  /* SR4: the older duplicate-link script hides the product name link in cart rows (it pairs it with the
     empty image link), so the name wasn't announced as a link. Restore the name link; the image link
     stays hidden. */
  function fixCartItemNames() {
    document.querySelectorAll('.cart-item__name[data-ada-wave09="demoted"]').forEach(function (a) {
      var href = a.getAttribute('data-ada-href');
      if (href && !a.getAttribute('href')) a.setAttribute('href', href);
      removeAttr(a, 'aria-hidden');
      removeAttr(a, 'role');
      removeAttr(a, 'tabindex');
      removeAttr(a, 'data-ada-wave09');
    });
    /* The number next to "Your cart" in the drawer was read as a bare number. */
    document.querySelectorAll('cart-drawer .drawer__header .total-cart').forEach(function (s) {
      setAttr(s, 'aria-hidden', 'true');
    });
  }

  /* Nested navigation landmark: the menu app's <nav> sits inside the theme's "Main menu" <nav>,
     so screen readers announced the main navigation twice. */
  function fixNestedNav() {
    document.querySelectorAll('nav nav.tmenu_navbar, [role="navigation"] nav.tmenu_navbar').forEach(function (n) {
      setAttr(n, 'role', 'none');
    });
  }

  /* SR3 + SR4: cart behaviour. Patched here (not in the theme's cart files) so rollback stays in one place. */
  function cartCountText() {
    return txt(document.querySelector('#cart-icon-bubble .cart-count-bubble .visually-hidden'));
  }
  function focusEl(el) {
    if (!el) return;
    if (!el.matches(FOCUSABLE)) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: false }); } catch (e) { el.focus(); }
  }
  function patchCart() {
    /* Dawn's trapFocus is called with a missing container when the last item is removed on the cart page;
       that threw, so the page showed "There was an error" and focus was lost. It also trapped focus inside
       the closed cart drawer after a quantity change on the cart page. */
    if (typeof window.trapFocus === 'function' && !window.trapFocus.__fh) {
      var origTrap = window.trapFocus;
      window.trapFocus = function (container, elementToFocus) {
        if (!container) { if (elementToFocus) focusEl(elementToFocus); return; }
        var drawer = container.closest && container.closest('cart-drawer');
        if (drawer && !drawer.classList.contains('active') && elementToFocus && !container.contains(elementToFocus)) {
          focusEl(elementToFocus);
          return;
        }
        return origTrap.apply(this, arguments);
      };
      window.trapFocus.__fh = true;
    }

    var CI = window.customElements && customElements.get('cart-items');
    if (CI && !CI.prototype.__fhPatched) {
      CI.prototype.__fhPatched = true;
      var origUpdate = CI.prototype.updateQuantity;
      CI.prototype.updateQuantity = function (line, quantity, name) {
        var inDrawer = this.tagName === 'CART-DRAWER-ITEMS';
        var row = document.getElementById((inDrawer ? 'CartDrawer-Item-' : 'CartItem-') + line);
        var title = txt(row && row.querySelector('.cart-item__name')).replace(/\s+$/, '');
        var before = cartCountText();
        var r = origUpdate.apply(this, arguments);
        var q = parseInt(quantity, 10);
        var started = Date.now();
        (function wait() {
          var list = document.getElementById(inDrawer ? 'CartDrawer-CartItems' : 'main-cart-items');
          var busy = list && list.classList.contains('cart__items--disabled');
          var changed = cartCountText() !== before;
          if ((busy || (!changed && Date.now() - started < 1500)) && Date.now() - started < 8000) { setTimeout(wait, 100); return; }
          var countTxt = cartCountText();
          var empty = /^0\b/.test(countTxt) || (!inDrawer && !!document.querySelector('cart-items.is-empty'));
          var msg;
          if (q === 0) msg = (title ? title + ' removed from cart.' : 'Item removed from cart.') + (empty ? ' Your cart is empty.' : (countTxt ? ' ' + countTxt + ' in cart.' : ''));
          else if (changed) msg = 'Quantity' + (title ? ' for ' + title : '') + ' updated to ' + q + '.' + (countTxt ? ' ' + countTxt + ' in cart.' : '');
          if (!inDrawer) {
            var ae = document.activeElement;
            if (!ae || ae === document.body) {
              if (empty) focusEl(document.querySelector('cart-items .cart__empty-text'));
              else {
                var newRow = document.getElementById('CartItem-' + line) || document.querySelector('#main-cart-items .cart-item');
                focusEl(newRow && (newRow.querySelector(name ? '[name="' + name + '"]' : '.quantity__input') || newRow.querySelector('.cart-item__name')));
              }
            }
            /* The theme's "There was an error" message was a side effect of the trapFocus bug above. */
            var err = document.getElementById('cart-errors');
            if (err && /error while updating/i.test(txt(err))) err.textContent = '';
          }
          if (msg) announce(msg, 500);
        })();
        return r;
      };
    }

    var CD = window.customElements && customElements.get('cart-drawer');
    if (CD && !CD.prototype.__fhPatched) {
      CD.prototype.__fhPatched = true;
      var origOpen = CD.prototype.open;
      CD.prototype.open = function () {
        var drawer = this;
        var res = origOpen.apply(this, arguments);
        /* Focusing the whole dialog made Orca read everything as one run-on string. Focus the
           "Your cart" heading instead (or "Your cart is empty" when empty). */
        var done = false, tries = 0;
        function moveFocus() {
          if (done || !drawer.classList.contains('active')) return;
          var ae = document.activeElement;
          if (ae && ae !== document.body && !ae.classList.contains('drawer__inner') && drawer.contains(ae) && ae.tagName !== 'CART-DRAWER') { done = true; return; }
          var h = drawer.classList.contains('is-empty')
            ? drawer.querySelector('.drawer__inner-empty .cart__empty-text')
            : drawer.querySelector('.drawer__inner > .drawer__header .drawer__heading') || drawer.querySelector('.drawer__heading');
          focusEl(h);
          /* Focus can't land while the drawer is still sliding in; try again shortly. */
          if (h && document.activeElement === h) done = true;
          else if (tries++ < 12) setTimeout(moveFocus, 150);
        }
        this.addEventListener('transitionend', function () { setTimeout(moveFocus, 0); }, { once: true });
        setTimeout(moveFocus, 300);
        return res;
      };
      var origRender = CD.prototype.renderContents;
      CD.prototype.renderContents = function (parsedState) {
        var res = origRender.apply(this, arguments);
        if (parsedState && parsedState.product_title) {
          var v = parsedState.variant_title && !/default title/i.test(parsedState.variant_title) ? ', ' + parsedState.variant_title : '';
          var qty = parsedState.quantity && parsedState.quantity > 1 ? parsedState.quantity + ' x ' : '';
          setTimeout(function () {
            var c = cartCountText();
            announce(qty + parsedState.product_title + v + ' added to cart.' + (c ? ' ' + c + ' in cart.' : ''), 0);
          }, 1200);
        }
        return res;
      };
    }
  }

  function runAll() {
    try { patchCart(); } catch (e) {}
    try { fixGloboClearControls(); } catch (e) {}
    try { fixGloboCardPrices(); } catch (e) {}
    try { fixGloboSort(); } catch (e) {}
    try { fixGloboPriceSliders(); } catch (e) {}
    try { fixCartItemNames(); } catch (e) {}
    try { fixNestedNav(); } catch (e) {}
  }

  var timer = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; runAll(); }, 60);
  }

  function start() {
    runAll();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
